<template>
  <div class="animated fadeIn pt2 pb4">
    <!-- desktop view -->
    <div class="flex justify-start gibson mt2 pl4 mb2" v-if="!showMobile">
      <div class="col-7">
        <div class="col-12 pt3">
          <p class="h4 darkblue gibson semi-bold">
            Anbefal os til en kammerat!
          </p>
          <p class="h5 darkblue regular line-height-3 my2">
            Du modtager et gratis “Fri entré”-kort til Tivoli, når din kammerat melder sig ind som partner hos Håndværker.dk via din sms-besked.
          </p>
        </div>
        <div class="py1"></div>
        <div class="col-12">
          <form class="highlights p3" @submit.stop.prevent="sendSMS()">
            <div class="clearfix">
              <p class="h4 darkblue gibson line-height-1 mb3">
                Indtast din kammerat's nummer her
              </p>
              <input type="text" placeholder="Telefonnummer" required v-model="telephone" @submit.stop.prevent="sendSMS()"  class="col-12 h5 p2 darkblue border-none gibson lightgrey-background">
              <textarea style="min-height:200px;" required class="col-12 border-none p2 h5 book gibson darkblue line-height-3 lightgrey-background" v-model="message"></textarea>
              <button type="submit" :disabled="isLoadingRecommend" class="col-12 action-button p2 h5 regular gibson line-height-1 not-rounded flex justify-center items-center">
                <span>Send sms</span>
                <span class="ml2"><i class="el-icon-right"></i></span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- mobile view -->
    <div class="flex flex-wrap justify-start gibson mt2" v-if="showMobile">
      <div class="col-12 pt0 pr0 pb0 pl3">
        <!-- back button -->
        <div @click="$router.go(-1)" class="clearfix primarycolor flex justify-start items-center">
          <span class="mr1"><i class="el-icon-back"></i></span>
          <span class="h5 gibson line-height-1 m0 p0">Tilbage</span>
        </div>
      </div>
      <div class="col-12 pt3 pb0 pl3">
        <p class="h4 darkblue gibson semi-bold">
          Anbefal os til en kammerat!
        </p>
        <p class="h5 regular darkblue line-height-golden gibson">
          Du modtager et gratis “Fri entré”-kort til Tivoli, når din kammerat melder sig ind som partner hos Håndværker.dk via din sms-besked.
        </p>
      </div>
      <div class="col-12 p3">
        <form class="highlights p3" @submit.stop.prevent="sendSMS()">
          <div class="clearfix">
            <p class="h5 darkblue gibson line-height-1 mb2">
              Indtast din kammerat's nummer her
            </p>
            <input type="text" placeholder="Telefonnummer"  required   v-model="telephone" class="col-12 h5 p2 darkblue border-none gibson lightgrey-background">
            <textarea style="min-height:200px;" required class="col-12 border-none p2 h5 gibson darkblue line-height-3 lightgrey-background"  v-model="message"></textarea>
            <button  type="submit" :disabled="isLoadingRecommend" class="col-12 action-button p2 h5 regular gibson line-height-1 not-rounded flex justify-center items-center">
              <span>Send sms</span>
              <span class="ml2"><i class="el-icon-right"></i></span>
            </button>
          </div>
        </form>
      </div>
    </div>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<script>
/* import axios from 'axios' */
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
export default {
  name: 'recommend',
  components: {
    loading,
    Simplert
  },
  data () {
    return {
      haaid: '',
      show: false,
      showMobile: false,
      isLoadingRecommend: false,
      label: 'Loading...',
      sampleReviewcs: '',
      telephone: '',
      overlay: 1,
      message: 'Hej. Jeg vil gerne anbefale dig at melde dig ind hos Håndværker.dk. Det er en hjemmeside, der giver fagfolk som os god markedsføring og opgaver fra boligejere. Hvis du bruger mit link til at melde dig ind hos Håndværker.dk, så modtager du et gratis \n "Fri entré"- kort til tivoli. https://www.haandvaerker.dk/business/referral/' + localStorage.getItem('haaid') + ''
    }
  },
  methods: {
    sendSMS () {
      if (this.telephone.length !== 8) {
        this.$toastr('error', 'Hov, noget gik galt. Nummeret skal indeholde 8 cifre.')
        return
      }
      this.isLoadingRecommend = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = { operation: 'addrecommendsms', salesPerson: this.salesPerson, telephone: this.telephone, message: this.message }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.telephone = ''
              let closeFn = function () {
                this.$router.push('/medlemsfordele')
              }
              let obj = {
                customClass: 'confirmDialog',
                customIconUrl: '',
                message: '<div class="flex flex-column justify-center items-center pt3"><img src="/static/svg/blue-checkmark.svg" width="50" height="50"><p class="h3 mt3 regular gibson darkblue line-height-2">Tak!</p></div>',
                type: 'success',
                customCloseBtnClass: 'muted-button gibson border-none not-rounded h5 regular p2 px3 right',
                customCloseBtnText: 'Luk',
                onClose: closeFn
              }
              this.$refs.simplert.openSimplert(obj)
              this.isLoadingRecommend = false
            } else {
              alert(res.message)
              this.isLoadingRecommend = false
            }
          },
          response => {
            alert('error')
            this.isLoadingRecommend = false
          }
        )
      window.dataLayer.push({ event: 'partner_recommend_sms' })
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
  },
  mounted () {
    try {
      /* axios
        .get('https://bitrixapi.haandvaerker.dk/v1/bitrix/getMembers')
        .then((res) => {
          this.medlemsfordele = res.data.data.data
        })
        .catch(function () {
          console.log('Error')
        }) */
    } catch (e) {
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// recommend.vue?1847d6b8